import CustomerSessionsPanel from './account/CustomerSessionsPanel'

export default function CustomerSessionsPage() {
  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 26, margin: '0 0 6px' }}>Aktive Sitzungen</h1>
        <p className="wc-muted" style={{ fontSize: 14, margin: 0 }}>
          Hier sehen Sie alle Geräte, auf denen Sie aktuell angemeldet sind.
        </p>
      </div>
      <CustomerSessionsPanel />
    </div>
  )
}
